import controller from './template-save-modal';
import template from './template-save-modal.pug';

class TemplateSaveService {
  /* @ngInject */
  constructor($uibModal) {
    this.$uibModal = $uibModal;
  }

  open(caseId, caseConfig, user) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          caseId: () => caseId,
          caseConfig: () => caseConfig,
          user: () => user,
        },
      })
      .result;
  }
}

export default TemplateSaveService;



// WEBPACK FOOTER //
// ./client/components/template-save/template-save-modal.service.js